//// Application Packages
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

//// Application Slices
import {
    updateFormData,
    updateFormValidity,
    selectForms,
} from '../../reducers/formSlice'

//// Carbon Components
import { Select, SelectItem } from '@carbon/react'

//// Application Components

//// Carbon Icons

//// Static Constants

//////// Component
const FileSelectorComponent = ({ digital_name }) => {
    //////// Hooks
    const dispatch = useDispatch()

    //////// State

    //////// Slices
    const formsData = useSelector(selectForms)

    //// Slice Data

    //////// Search Params

    //////// Methods

    // Re-Validate Data Submission
    const revalidation = async (event_name) => {
        try {
            // Update Validation State
            if (event_name) {
                dispatch(
                    updateFormValidity({
                        digital_name: 'file-attachments',
                        errors: {
                            [event_name]: false,
                            [event_name + 'ErrMsg']: '',
                        },
                    })
                )
            }
        } catch (error) {
            console.warn('Revalidation Error:', error)
            return null
        }
    }

    // Handle Static Data Of All Fields
    const handleStaticData = () => {
        // Check For Form By Digital Name
        if (
            digital_name === 'criminal-history' ||
            digital_name === 'sealed-criminal-history' ||
            digital_name === 'criminal-and-medicaid-medicare-fraud-questions'
        ) {
            dispatch(
                updateFormData({
                    digital_name: 'file-attachments',
                    values: {
                        FileUpldDcmtType: 'criminal-history-documents',
                    },
                })
            )
        } else if (digital_name === 'discipline-history') {
            dispatch(
                updateFormData({
                    digital_name: 'file-attachments',
                    values: {
                        FileUpldDcmtType: 'letters-of-reference',
                    },
                })
            )
        } else if (digital_name === 'health-history') {
            dispatch(
                updateFormData({
                    digital_name: 'file-attachments',
                    values: {
                        FileUpldDcmtType:
                            'initial-application-supporting-documentation',
                    },
                })
            )
        } else {
            dispatch(
                updateFormData({
                    digital_name: 'file-attachments',
                    values: {
                        FileUpldDcmtType: '',
                    },
                })
            )
        }
    }

    // Handle Data Of All Fields
    const handleData = (e) => {
        if (e?.target?.name && e?.target?.value) {
            dispatch(
                updateFormData({
                    digital_name: 'file-attachments',
                    values: {
                        [e.target.name]: e.target.value,
                    },
                })
            )
            revalidation(e.target.name)
        } else if (e?.target?.name) {
            dispatch(
                updateFormData({
                    digital_name: 'file-attachments',
                    values: { [e.target.name]: '' },
                })
            )
            revalidation(e.target.name)
        }
        //// Start Watson Assistant Journey

        //// End Watson Assistant Journey
    }

    //////// Functional Methods

    //////// Memoization

    //////// Effects/Side Effects

    // Set Document Type On Load
    useEffect(() => {
        if (digital_name) {
            handleStaticData()
        }
        return () => {}
    }, [digital_name])

    //////////////// Render & Return
    if (
        digital_name === 'criminal-history' ||
        digital_name === 'sealed-criminal-history' ||
        digital_name === 'criminal-and-medicaid-medicare-fraud-questions'
    ) {
        return (
            <>
                <Select
                    className=""
                    defaultValue={'criminal-history-documents'}
                    value={'criminal-history-documents'}
                    helperText=""
                    labelText={'Document Type:'}
                    name="FileUpldDcmtType"
                    id="FileUpldDcmtType"
                    onChange={handleStaticData}
                    invalid={
                        formsData?.['file-attachments']?.errors
                            ?.FileUpldDcmtType
                    }
                    invalidText={
                        formsData?.['file-attachments']?.errors
                            ?.FileUpldDcmtTypeErrMsg
                    }
                >
                    <SelectItem
                        text="Criminal History Documents"
                        value="criminal-history-documents"
                    />
                </Select>
            </>
        )
    } else if (digital_name === 'discipline-history') {
        return (
            <>
                <Select
                    className=""
                    defaultValue={'letters-of-reference'}
                    value={'letters-of-reference'}
                    helperText=""
                    labelText={'Document Type:'}
                    name="FileUpldDcmtType"
                    id="FileUpldDcmtType"
                    onChange={handleStaticData}
                    invalid={
                        formsData?.['file-attachments']?.errors
                            ?.FileUpldDcmtType
                    }
                    invalidText={
                        formsData?.['file-attachments']?.errors
                            ?.FileUpldDcmtTypeErrMsg
                    }
                >
                    <SelectItem text="Choose an option" value="" />
                    <SelectItem
                        text="Letters of Reference"
                        value="letters-of-reference"
                    />
                </Select>
            </>
        )
    } else if (digital_name === 'health-history') {
        return (
            <>
                <Select
                    className={''}
                    defaultValue={
                        'initial-application-supporting-documentation'
                    }
                    value={'initial-application-supporting-documentation'}
                    helperText=""
                    labelText={'Document Type:'}
                    name="FileUpldDcmtType"
                    id="FileUpldDcmtType"
                    onChange={handleStaticData}
                    invalid={
                        formsData?.['file-attachments']?.errors
                            ?.FileUpldDcmtType
                    }
                    invalidText={
                        formsData?.['file-attachments']?.errors
                            ?.FileUpldDcmtTypeErrMsg
                    }
                >
                    <SelectItem
                        text="Initial Application Supporting Documentation"
                        value="initial-application-supporting-documentation"
                    />
                </Select>
            </>
        )
    } else {
        return (
            <>
                <Select
                    className=""
                    defaultValue={
                        formsData?.['file-attachments']?.values
                            ?.FileUpldDcmtType
                    }
                    value={
                        formsData?.['file-attachments']?.values
                            ?.FileUpldDcmtType
                            ? formsData?.['file-attachments']?.values
                                  ?.FileUpldDcmtType
                            : ''
                    }
                    helperText=""
                    labelText={'Document Type:'}
                    name="FileUpldDcmtType"
                    id="FileUpldDcmtType"
                    onChange={handleData}
                    invalid={
                        formsData?.['file-attachments']?.errors
                            ?.FileUpldDcmtType
                    }
                    invalidText={
                        formsData?.['file-attachments']?.errors
                            ?.FileUpldDcmtTypeErrMsg
                    }
                >
                    <SelectItem text="Choose an option" value="" />
                    <SelectItem text="Certificate" value="certificate" />
                    <SelectItem
                        text="Continuing Education"
                        value="continuing-education"
                    />
                    <SelectItem
                        text="Criminal History Documents"
                        value="criminal-history-documents"
                    />
                    <SelectItem
                        text="Education Documents"
                        value="education-documents"
                    />
                    <SelectItem
                        text="Financial Responsibility"
                        value="financial-responsibility"
                    />
                    <SelectItem
                        text="Initial Application Supporting Documentation"
                        value="initial-application-supporting-documentation"
                    />
                    <SelectItem text="Insurance" value="insurance" />
                    <SelectItem
                        text="Letters of Reference"
                        value="letters-of-reference"
                    />
                    <SelectItem
                        text="Marriage License"
                        value="marriage-license"
                    />
                    <SelectItem
                        text="Military Documents"
                        value="military-documents"
                    />
                    <SelectItem
                        text="Miscellaneous Documents"
                        value="miscellaneous-documents"
                    />
                    <SelectItem
                        text="Qualified Supervisor"
                        value="qualified-supervisor"
                    />
                </Select>
            </>
        )
    }
}

export default FileSelectorComponent
